/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZUpdateAssetApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface UpdateAssetPutRequest {
  type?: string
  id: string
  name: string
  description: string
  modem_id?: string
  gateway_id?: string
  asset_type_id?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateAssetApiResponse,
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type UpdateAssetApiResponse = z.infer<typeof ZUpdateAssetApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateAsset (
  updateAssetPutRequest: UpdateAssetPutRequest,
  onSuccess: (successResponse: UpdateAssetApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .put(url, updateAssetPutRequest, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          // istanbul ignore next
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        // istanbul ignore next
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        // istanbul ignore next
        onFailure('Network Error', 404)
      }
    })
}
